import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Error404 from "../views/404.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/meeting/:order_uuid",
    name: "Home",
    component: Home
  },
      {
    path: '/404',
    name: '404',
    component: Error404,
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
      {
      path: '*',
      redirect: '404',
    },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
